
export const Loading = () => {
  return (
    <div
      style={{
        width: "40px",
        height: "22px",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "14px",
          height: "14px",
          border: "2px solid #ccc",
          borderTop: "2px solid #00b86b",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}
      />
      <style>
        {`@keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
          }`}
      </style>
    </div>
  );
};